import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { Header, TableStandard } from "ui"
import { useManageModal } from "ui"
import { useEffect, useState } from "react"
import { splitCamelCase } from "../../../../tools/splitCamelCase"
import { CompanySessionStats } from "../../../../__generated__/graphql"
import { Typography, Box, IconButton } from "@mui/material"
import { Help } from "@mui/icons-material"
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "color", headerName: "Color Code", flex: 1, sortable: false, resizable: false, disableColumnMenu: true,
        renderCell: ({ value }) => (
            <Box sx={{
                backgroundColor: value,
                width: "100%",
                height: "100%",
                borderRadius: 1
            }} />
        )
    },
    { field: "disposition", headerName: "Disposition", flex: 3, sortable: false, resizable: false, disableColumnMenu: true, },
    { field: "count", headerName: "Count", headerAlign: "center", align: "center", flex: 1, sortable: false, resizable: false, disableColumnMenu: true, },
]
type DispositionKey = keyof CompanySessionStats;
const allowedFields: DispositionKey[] = ["crisisSupportIndicated", "intensiveSupportIndicated", "supportIndicated", "preventionAndStrengthIndicated"]
const mappedColors = {
    "crisisSupportIndicated": "#F4CCCC",
    "intensiveSupportIndicated": "#FCE5CD",
    "supportIndicated": "#FFF2CC",
    "preventionAndStrengthIndicated": "#D9EAD3"
} as const
const DispositionTable = ({ dispositionCount }: { dispositionCount: CompanySessionStats | null }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })
    const { openModal } = useManageModal()
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = dispositionCount
                ? allowedFields.map(key => ({
                    id: key,
                    color: mappedColors[key as keyof typeof mappedColors],
                    disposition: splitCamelCase(key),
                    count: dispositionCount[key]
                }))
                : [];

            return {
                ...prevState,
                columns,
                rows: rows
            }
        })
    }, [dispositionCount])
    const showDispoDetails = () => {
        openModal({ type: "DISPOSITION_DETAILS", cancelButtonLabel: "Close" })
    }
    return (
        <TableStandard
            renderToolbar={() => (
                <Box>
                    <Typography variant="h5" sx={{
                        width: "100%",
                        padding: "16px 16px",
                        // justifyContent: "space-between",
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                    }}>Disposition
                        <IconButton onClick={showDispoDetails}>
                            <Help sx={{ color: "gray" }} />
                        </IconButton>
                    </Typography>
                    {/* <Header title={`Disposition `} titleSize="p" /> */}

                </Box>
            )}
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            disableBoxShadow
            hideFooter={true}
            loading={false} />
    )
}
export default DispositionTable